import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PhxIconModule } from '../icon/icon.module';
import { PhxSkeletonModule } from '../skeleton/phx-skeleton.module';
import { PhxNavigationButtonComponent } from './phx-navigation-button.component';
import { PhxTileModule } from '../tile/phx-tile.module';

@NgModule({
  imports: [CommonModule, PhxTileModule, PhxIconModule, PhxSkeletonModule],
  declarations: [PhxNavigationButtonComponent],
  exports: [PhxNavigationButtonComponent],
})
export class PhxNavigationButtonModule {}
